import * as API from '../_api';

import uuidv4 from 'uuid/v4';

const randomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

// @ts-ignore
export const create = async ({dispatch}, one) => {
  try {
    await API.create(one);
    dispatch('snackbar/success', 'Datei wurde hinzugefügt', {root: true});
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const read = async ({commit, dispatch}) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const del = async ({dispatch}, user) => {
  try {
    await API.del(user);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const update = async ({dispatch}, file) => {
  try {
    await API.update(file);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};

// @ts-ignore
export const uploadFile = async ({dispatch}, file) => {
  try {
    const uuid = uuidv4();
    let filename = file.name.split('.');
    const ext = filename.pop();
    filename = filename.join('.');
    filename = `${uuid}/${stringToSlug(filename)}.${ext}`;
    await API.uploadFile(`files/${filename}`, file);
    return filename;
  } catch (ex) {
    dispatch('snackbar/error', ex, {root: true});
    return false;
  }
};


function stringToSlug(str: string) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  const to = 'aaaaeeeeiiiioooouuuunc------';
  let i = 0;
  const l = from.length;
  for (; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-'); // collapse dashes

  return str;
}
